import React, { useEffect, useState } from 'react';
import './MobileSegmentTabs.css';

/**
 * iOS/Groww-style segmented control for mobile action boards.
 */
export default function MobileSegmentTabs({
  tabs,
  value,
  onChange,
  className = ''
}) {
  return (
    <div className={`mobile-seg ${className}`.trim()} role="tablist">
      {tabs.map((tab) => {
        const active = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`mobile-seg-btn${active ? ' active' : ''}${tab.urgent ? ' urgent' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            <span className="mobile-seg-label">{tab.label}</span>
            {tab.count != null && (
              <em className="mobile-seg-count">{tab.count}</em>
            )}
          </button>
        );
      })}
    </div>
  );
}

/** Pick initial segment from pipeline step (1=buy, 2=sell, 3=hold). */
export function useActionSegment(activeStep, preferSell = false) {
  const resolve = (step, prefer) => {
    if (prefer || step === 2 || step === 'sell') return 'sell';
    if (step === 3 || step === 'hold') return 'hold';
    if (step === 1 || step === 'buy') return 'buy';
    return 'buy';
  };
  const [segment, setSegment] = useState(() => resolve(activeStep, preferSell));
  useEffect(() => {
    setSegment(resolve(activeStep, preferSell));
  }, [activeStep, preferSell]);
  return [segment, setSegment];
}
